import { render } from "./accountset.vue?vue&type=template&id=7d4a0220"
import script from "./accountset.vue?vue&type=script&lang=js"
export * from "./accountset.vue?vue&type=script&lang=js"

import "./accountset.vue?vue&type=style&index=0&id=7d4a0220&lang=css"
import "./accountset.vue?vue&type=style&index=1&id=7d4a0220&lang=css"
script.render = render

export default script